<template>
	<button
		v-tooltip="$t('bookmarks.name')"
		type="button"
		:aria-label="$t('bookmarks.name')"
		data-testid="bookmarks-shortcut-trigger"
		@click="$emit('click')"
	>
		<SuiIcon class="bookmarks-button__icon" name="icon-bookmark-24" />
	</button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SuiIcon } from '@developers/scoro-ui';

export default defineComponent({
	components: {
		SuiIcon,
	},

	emits: ['click'],
});
</script>

<style lang="scss">
.bookmarks-button {
	&__icon.sui-icon {
		fill: $neutral-80;
	}
}
</style>
